import { getConfirmConfigurationOption } from './confirmConfiguration';

export function ConfirmButtonViewConstructor(services) {
  
  let joint = services.joint;

  return joint.shapes.html.AbstractElementView.extend({
    isElementEditable: true,
    isElementDeletable : false,
    editElementModalController: 'editConfirmButtonController',
    editElementModalTemplate: require('./editConfirmButton.modal.html'),
    angularTemplate: require('./ConfirmButtonView.html'),

    afterEditElement: function(oldElementData, newElementData) {
      this.updatePortAndLink();
    },

    updateBox: function() {
      joint.shapes.html.AbstractElementView.prototype.updateBox.apply(this, arguments);
      this.updatePortAndLink();
    },

    /**
     * As postback button can have outgoing links,
     * but web URL buttons cannot,
     * we need to update the port accordingly after editing the button,
     * possibly removing an existing outgoing link  
     */
    updatePortAndLink: function() {
      if (this.model.hasPort('out') && !this.currentTypeHasOutPort()) {
        this.model.removeOutPort('out');
      } else if (!this.model.hasPort('out') && this.currentTypeHasOutPort()) {
        this.model.addOutPort('out');
      }
    },

    /**
     * Tells whether this button should have an outPort
     * and hence can be connected to other boxes of the graph,
     * depending on its selected type.
     */
    currentTypeHasOutPort() {
      return this.angularScope.elementData.type !== 'url';
    },

    getConfigurationOption: function (key) {
      return getConfirmConfigurationOption(key);
    },
});
}
